/*!
 * @utiljs/guid 0.5.4 (http://git.sankuai.com/projects/WM/repos/utiljs/browse/packages/base/)
 * API http://git.sankuai.com/projects/WM/repos/utiljs/browse/packages/base/doc/api.md
 * Copyright 2017-2019 美团mfe. All Rights Reserved
 * Licensed under MIT (http://git.sankuai.com/projects/WM/repos/utiljs/browse/packages/base/LICENSE)
 */

function Guid() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  index = Math.round(index);

  if (isNaN(index)) {
    index = 0;
  }

  this.index = index;
}

Guid.prototype.guid = function () {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  prefix = String(prefix);
  return prefix + this.index++;
};

var g = new Guid();
function guid(prefix) {
  return g.guid(prefix);
}
function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  }).toUpperCase();
}

export { Guid, guid, uuid };
